import { Button, FormGroup } from "reactstrap";
import { file, plus, reset, saveIcon, saveMapping } from "../../../../../constant/icons";
import ReactSelect from "react-select";
import { useEffect, useMemo, useState } from "react";
import moment from "moment"; // Add this import
import { FileUpload, columnMap, sheetSet } from "../../../type";
import { COLUMNS_DETECTED } from "../../../message";
import { NewMap, UpdateMapChanges } from "../../addNewMap";
import Swal from "sweetalert2";
import { confirmBox } from "../../../../../components/toast";

const ColumnsMap = (props: any) => {
  const { selectedMap, resetId, setSelectedMap, fileUpload, onFileUpdate, refresh, app, setColumnMappingData ,dateValidationResults, setDateValidationResults} = props;
  const [currentFileIndex, setCurrentFileIndex] = useState(0);
  const [askNewMap, setAskNewMap] = useState<boolean>(false);
  const [allMappings, setAllMappings] = useState<any[]>([]);
  const [dateMappings, setDateMappings] = useState<{ [destinationLabel: string]: string }>({}); 
  const expectedDate = app?.conversation?.company_settings?.dateFormat
  console.log("expectedDate>>>>>>>>>>>>>>>>>>",expectedDate);

  useEffect(() => {
    if (resetId) {
      confirmBox("Do you want to clear", "clear map").then((result) => {
        if (result) {
          const columnMap = fileUpload[currentFileIndex]?.selectedSheet?.[0]?.columnMap;
          if (columnMap) {
            for (let yo = 0; yo < columnMap.length; yo++) {
              columnMap[yo].Source = "";
            }
            onFileUpdate(fileUpload);
            setAllMappings((prev) =>
              prev.map((m) =>
                m.fileIndex === currentFileIndex
                  ? {
                      ...m,
                      mappings: columnMap?.map((col: any) => ({
                        sourceColumn: col.Source,
                        destinationColumn: col.DestinationCode || col.DestinationLabel,
                        destinationColumnLabelName: col.DestinationLabel,
                      })),
                    }
                  : m
              )
            );
            setDateMappings({});
            setDateValidationResults({});
          }
        }
      });
    }
  }, [resetId]);

  useEffect(() => {
    if (Object.keys(dateMappings).length > 0 && fileUpload[currentFileIndex]) {
      const results = validateAllDateColumns();
      setDateValidationResults(results);
      console.log("Date Validation Results:", results);
    }
  }, [dateMappings, fileUpload, currentFileIndex, setDateValidationResults]);

  const extractUniqueColumnValues = (sourceColumn: string) => {
    const currentFile = fileUpload[currentFileIndex];
    const selectedSheet = currentFile?.selectedSheet?.[0];
    const sheetData = currentFile?.totalSheet?.find((x: sheetSet) => x.name === selectedSheet?.name);
    console.log(`DEBUG - Extracting for source column: ${sourceColumn}, sheetData:`, sheetData); 
    if (!sheetData || !sheetData.sourceColumnList || !sheetData.rowData) {  
      console.error(`DEBUG - No rowData for ${sourceColumn}. Structure issue?`);
      return new Set<string>();
    }
    
    const headers = sheetData.sourceColumnList[0];
    console.log(`DEBUG - Headers:`, headers); 
    
    const columnIndex = headers.findIndex((header: string) => header.trim().toUpperCase() === sourceColumn.trim().toUpperCase());
    console.log(`DEBUG - Column index for ${sourceColumn}:`, columnIndex);
    
    if (columnIndex === -1) {
      console.error(`DEBUG - Source column ${sourceColumn} not found in headers.`);
      return new Set<string>();
    }
    
    const uniqueValues = new Set<string>();
    sheetData.rowData.forEach((row: any[]) => { 
      const rawValue = row[columnIndex];
      const value = rawValue ? rawValue.toString().trim() : "";
      if (value && value.length > 0) {
        uniqueValues.add(value); 
      }
    });
    
    console.log(`DEBUG - Unique values for ${sourceColumn}:`, Array.from(uniqueValues)); 
    return uniqueValues;
  };


const getAllowedMomentFormats = (): string[] => {
  const fmt = expectedDate;
  if (fmt === "dd/MM/yyyy") {
    return ["DD/MM/YYYY", "DD-MM-YYYY"];
  }
  if (fmt === "MM/dd/yyyy") {
    return ["MM/DD/YYYY", "MM-DD-YYYY"];
  }
  return ["DD/MM/YYYY", "DD-MM-YYYY"];
};

const normaliseDateParts = (value: string): string => {
  const parts = value.split(/[/\-]/).map(p => p.trim()).filter(Boolean);
  if (parts.length !== 3) return value;
  const [day, month, year] = parts.map(p => p.padStart(2, '0'));
  const separator = value.includes('/') ? '/' : '-';
  return `${day}${separator}${month}${separator}${year}`;
};

const validateSourceColumnDatesStrict = (sourceColumn: string): boolean => {
  const uniqueValues = extractUniqueColumnValues(sourceColumn);
  if (uniqueValues.size === 0) return false;
  const allowedFormats = getAllowedMomentFormats();
  let columnIsValid = true;
  uniqueValues.forEach((raw: string) => {
    const trimmed = raw.trim();
    if (!trimmed) return;
    const normalised = normaliseDateParts(trimmed);
    const matches = allowedFormats.some(fmt =>
      moment(normalised, fmt, true).isValid()
    );
    if (!matches) {
      console.log(`Invalid date after normalisation → "${trimmed}" → "${normalised}"`);
      columnIsValid = false;
    }
  });

  return columnIsValid;
};

  const validateAllDateColumns = () => {
    const results = {
      dateDetection: {} as { [destinationLabel: string]: boolean },  
      isMatchedAsExpected: {} as { [sourceColumn: string]: boolean } 
    };

    Object.keys(dateMappings).forEach((destinationLabel) => {
      results.dateDetection[destinationLabel] = true;  
    });

    const uniqueSources = Array.from(new Set(Object.values(dateMappings))).filter(Boolean);  
    console.log(`DEBUG - Unique sources to validate:`, uniqueSources); 
    uniqueSources.forEach((sourceColumn: string) => {
      results.isMatchedAsExpected[sourceColumn] = validateSourceColumnDatesStrict(sourceColumn);
    });

    return results;
  };

  const getHasDateValidation = (destinationCode: string, currentFunctionCode: string) => {
    try {
      const currentFunction = app.currentApp.functionList.find((func: any) => func.functionCode === currentFunctionCode);
      console.log("DEBUG - currentFunctionColumns:", currentFunction?.functionColumns); 

      if (currentFunction && currentFunction.functionColumns) {
        const column = currentFunction.functionColumns.find((col: any) => 
          col.columnId === destinationCode || col.columnLabel === destinationCode
        );
        if (column && column.validation) {
          const parsedValidation = JSON.parse(column.validation);
          return parsedValidation?.type?.value === 2;
        }
      }
    } catch (error) {
      console.error("Error checking date validation:", error);
    }
    return false;
  };

  const buildDateMappingsFromTemplate = (startIndex: number, endIndex: number) => {
    const newDateMappings: { [destinationLabel: string]: string } = {};
    
    for (let i = startIndex; i < endIndex; i++) {
      const selectedSheet = fileUpload[i]?.selectedSheet?.[0];
      if (selectedSheet && selectedSheet.columnMap) {
        const currentFunctionCode = selectedSheet.functionCode;
        selectedSheet.columnMap.forEach((item: any) => {
          const hasDate = getHasDateValidation(item.DestinationCode || item.DestinationLabel, currentFunctionCode);
          const sourceColumn = item.Source;
          if (hasDate && sourceColumn && sourceColumn.trim().length > 0) {
            newDateMappings[item.DestinationLabel.trim()] = sourceColumn;
          }
        });
      }
    }
    
    setDateMappings((prev) => ({ ...prev, ...newDateMappings }));
    console.log("DEBUG - Built dateMappings from template:", newDateMappings);
  };

  const mapingMainHead = useMemo(
    () => (
      <ul className="maping-main-head">
        <li>
          <label>File name</label>
          <span>{fileUpload[currentFileIndex].file.name}</span>
        </li>
        <li>
          <label>Sheet name</label>
          <span>{fileUpload[currentFileIndex]?.selectedSheet?.[0]?.name ?? ""}</span>
        </li>
        <li>
          <label>Function name</label>
          <span>{app.getSelectedFunctionItem(fileUpload[currentFileIndex]?.selectedSheet?.[0]?.functionCode)?.label ?? ""}</span>
        </li>
        <li className="ms-auto">
          <FormGroup className="form-floating">
            <ReactSelect
              menuPortalTarget={document.body}
              menuPlacement="auto"
              menuPosition={"fixed"}
              isClearable={true}
              value={selectedMap}
              onChange={(newValue: any) => {
                if (newValue) {
                  Swal.fire({
                    title: "Do you want to update Mapping?",
                    showDenyButton: true,
                    showCancelButton: true,
                    confirmButtonText: "Only current File",
                    denyButtonText: `Update all`,
                    cancelButtonText: `Cancel`,
                    width: "38rem",
                  }).then((result) => {
                    if (result.isConfirmed || result.isDenied) {
                      Swal.fire({
                        title: "Would you like to overwrite mapped columns?",
                        showDenyButton: true,
                        confirmButtonText: "Yes",
                        denyButtonText: `No`,
                        cancelButtonText: `Cancel`,
                        showCancelButton: true,
                        width: "50rem",
                      }).then((resultOver) => {
                        const startIndex = result.isConfirmed ? currentFileIndex : 0;
                        const endIndex = result.isConfirmed ? currentFileIndex + 1 : fileUpload.length;
                        
                        for (let i = startIndex; i < endIndex; i++) {
                          const selectedSheet = fileUpload[i]?.selectedSheet?.[0];
                          if (selectedSheet) {
                            const currentFunctionMap = newValue.value.payloadMap.find(
                              (x: any) => x.function.functionCode === selectedSheet.functionCode
                            );
                            if (currentFunctionMap && selectedSheet.columnMap && currentFunctionMap.payloadMap) {
                              (JSON.parse(currentFunctionMap.payloadMap) as any[])?.forEach((item: any) => {
                                const column = selectedSheet.columnMap.find((x: any) => x.DestinationCode === item.DestinationCode);
                                if (column && (resultOver.isConfirmed || (column.Source === undefined || column.Source === null || column.Source.length <= 0))) {
                                  try {
                                    let valuesSource = fileUpload[i]?.totalSheet[0].sourceColumnList[0].find(
                                      (cx: any) => cx.toString().trim().toUpperCase() === item.Source.toString().trim().toUpperCase()
                                    );
                                    if (valuesSource) {
                                      column.Source = valuesSource;
                                    }
                                  } catch {}
                                }
                              });
                            }
                          }
                          if (result.isConfirmed) {
                            break;
                          }
                        }
                        onFileUpdate(fileUpload);
                        buildDateMappingsFromTemplate(startIndex, endIndex);
                        setSelectedMap(newValue);
                        setAllMappings((prev) =>
                          prev.map((m) =>
                            m.fileIndex === currentFileIndex
                              ? {
                                  ...m,
                                  mappings: fileUpload[currentFileIndex]?.selectedSheet?.[0]?.columnMap?.map((col: any) => ({
                                    sourceColumn: col.Source,
                                    destinationColumn: col.DestinationCode || col.DestinationLabel,
                                    destinationColumnLabelName: col.DestinationLabel,
                                  })) || [],
                                }
                              : m
                          )
                        );
                      });
                    }
                  });
                } else {
                  setSelectedMap(null);
                }
              }}
              options={app.getMapDropDownList()}
              placeholder={<div>Select mapped file</div>}
            />
          </FormGroup>
        </li>
        <li className="m-0 d-flex gap-3">
        {selectedMap && <Button className="btn btn-success btn-save" title="Save Mapping" onClick={
        async () => {
          if (selectedMap?.value?.id > 0) {
            const result = await UpdateMapChanges(selectedMap?.value?.id, "", NewMapCurrentFunction.id, NewMapCurrentFunction.columnMap)
            if (result && result.status) {
              await app.refreshAppInfo()
            }
          }
          else {
            setAskNewMap(true)
          }
        }} type="button">{saveIcon.icon}Save</Button>}
          <Button className="btn btn-danger btn-add" title="Add Mapping" onClick={() => setAskNewMap(true)} type="button">
            {plus.icon}Add
          </Button>
        </li>
      </ul>
    ),
    [currentFileIndex, fileUpload, refresh, selectedMap, askNewMap]
  );

  let convertSelectValue = (item: string | undefined) => {
    try {
      if (item && item.toString().trim().length > 0) {
        return {
          value: item.toString(),
          label: item.toString(),
        };
      }
    } catch {}
    return undefined;
  };

  let getColumnsList = useMemo(() => {
    const currentFile = fileUpload[currentFileIndex];
    const renderId = 1 + Math.random() * (100 - 1);
    const currentFunctionCode = fileUpload[currentFileIndex]?.selectedSheet?.[0]?.functionCode;

    if (currentFile) {
      const selectedSheet = currentFile?.selectedSheet?.[0];
      if (selectedSheet) {
        const columnMap = selectedSheet.columnMap;
        if (columnMap && columnMap.length > 0) {
          return columnMap.map((item: columnMap, index: number) => {
            return (
              <div key={`k${renderId}f${currentFileIndex}ks${index}`} className="column-data-list">
                <FormGroup id={`Gf${currentFileIndex}gs${index}`} className="form-floating">
                  <ReactSelect
                    className="column_field_select"
                    menuPortalTarget={document.body}
                    menuPlacement="auto"
                    menuPosition={"fixed"}
                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                    isClearable={true}
                    id={`f${currentFileIndex}s${index}`}
                    name={`f${currentFileIndex}s${index}`}
                    value={convertSelectValue(item.Source)}
                    placeholder={<div>Select column field</div>}
                    options={currentFile?.totalSheet?.find((x: sheetSet) => x.name === selectedSheet?.name)?.sourceColumnList?.[0].map((item: any) => ({
                      value: item,
                      label: item,
                    }))}
                    onChange={(newValue: any) => {
                      if (newValue && newValue.value) {
                        item.Source = newValue.value;
                      } else {
                        item.Source = "";
                      }
                      onFileUpdate(fileUpload);
                      setAllMappings((prev) => {
                        const existingIndex = prev.findIndex((m) => m.fileIndex === currentFileIndex);
                        const newMappings = fileUpload[currentFileIndex]?.selectedSheet?.[0]?.columnMap?.map((col: any) => ({
                          sourceColumn: col.Source,
                          destinationColumn: col.DestinationCode || col.DestinationLabel,
                          destinationColumnLabelName: col.DestinationLabel,
                        })) || [];
                        if (existingIndex >= 0) {
                          const updated = [...prev];
                          updated[existingIndex] = { fileIndex: currentFileIndex, mappings: newMappings };
                          return updated;
                        } else {
                          return [...prev, { fileIndex: currentFileIndex, mappings: newMappings }];
                        }
                      });
                      const sourceColumn = newValue?.value || "";
                      const destinationColumn = item.DestinationCode || item.DestinationLabel;
                      const destinationLabel = item.DestinationLabel; 
                      const hasDateValidation = getHasDateValidation(destinationColumn, currentFunctionCode);

                      console.log("Column mapping updated:", {
                        sourceColumn,
                        destinationColumn,
                        destinationLabel,
                        fileIndex: currentFileIndex,
                        fileName: fileUpload[currentFileIndex]?.file?.name,
                        sheetName: fileUpload[currentFileIndex]?.selectedSheet?.[0]?.name,
                        hasDateValidation,
                      });

                      // ONLY if value === 2, console JUST sourceColumn and destinationColumn
                      if (hasDateValidation && sourceColumn) {
                        console.log({
                          sourceColumn,
                          destinationColumn,
                        });
                      }

                      setDateMappings((prev) => {
                        const newMappings = { ...prev };
                        if (hasDateValidation && sourceColumn) {
                          newMappings[destinationLabel.trim()] = sourceColumn; 
                        } else if (!sourceColumn) {
                          delete newMappings[destinationLabel.trim()];
                        }
                        console.log("DEBUG - Updated dateMappings:", newMappings); 
                        return newMappings;
                      });

                      console.log("allMappings=====>>>>>>", allMappings, fileUpload);
                    }}
                  />
                </FormGroup>
                <label
                  className={item.requiredInfo ? "connector iscomment" : "connector"}
                >
                  {item.DestinationLabel}
                  {(item.isRequired || (item.requiredInfo && item.requiredInfo?.toString().trim().length > 1)) && (
                    <span style={{ color: item.isRequired ? "red" : "blue" }}>*</span>
                  )}
                </label>
                <span className="component-example">{item.requiredInfo}</span>
              </div>
            );
          });
        }
      }
    }
    return <h6>{COLUMNS_DETECTED}</h6>;
  }, [currentFileIndex, fileUpload, refresh, app]);

  const mapToggle = () => {
    setAskNewMap(false);
  };
  const NewMapCurrentFunction = {
    columnMap: fileUpload[currentFileIndex]?.selectedSheet?.[0]?.columnMap,
    ...app.getFunction(fileUpload[currentFileIndex]?.selectedSheet?.[0]?.functionCode),
  };

  return (
    <div>
      {askNewMap && (
        <NewMap app={app} currentFunction={NewMapCurrentFunction} mapToggle={mapToggle} isOpen={askNewMap} />
      )}
      <div className="column-maping">
        <div className="column-maping-box">
          <ul className="column-file-list small-scroll">
            {fileUpload.map((fileItem: FileUpload, indexOfColumnMap: number) => {
              return (
                <li
                  className={indexOfColumnMap === currentFileIndex ? "active" : ""}
                  onClick={() => setCurrentFileIndex(indexOfColumnMap)}
                >
                  {file.icon}
                  <p>{fileItem.file.name}</p>
                </li>
              );
            })}
          </ul>
          <div className="column-maping-list-data">
            {mapingMainHead}
            <div>
              <ul className="column-header">
                <li>Source Column</li>
                <li>Destination Column</li>
                <li>MMC Remark</li>
                <li></li>
              </ul>
              <div className="column-body small-scroll">{getColumnsList}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export { ColumnsMap };